import React from 'react';
import Header from "../../header/Header";
import {Link} from "react-router-dom";
import IconName from "../../../svgLogo/SvgLogo";
import TimerCart from "../timer-cart/TimerCard";
import Footer from "../../footer/Footer";
import Bundle from "../../singlePage/Bundle";

const BundlesPage = () => {
    return (
        <div className="bundles-page-wrapper">
            <Header/>
            <div className="bundles-page-content">
                <div className="header-box xpx-0 xpx-lg-6">
                    <nav className="nav-link-header d-flex justify-content-center">
                        <ul className="nav xp-2 xp-lg-3">
                            <li className="nav-item"><Link to="/specialOfferPage" className="nav-link"><IconName
                                name="stars" className="icon"/> <span
                                className="text">پیشنهاد ویژه</span></Link></li>

                            <li className="nav-item"><Link to="/bundlesPage" className="nav-link active"><IconName
                                name="library_add" className="icon"/> <span
                                className="text">باندل ها</span></Link></li>
                        </ul>
                    </nav>
                    <div className="offer-timer xpx-2 xpy-8 d-flex justify-content-center flex-column text-center">
                        <h2 className="title xmb-3">پایان هفته های شگفت انگیز</h2>
                        <div className="text-box d-flex justify-content-center">
                            <p className="text-offer">
                                طبق روال قبلی، پایان هفته های شگفت انگیز ما، از روز پنجشنبه شروع میشه و تا آخر روز جمعه
                                ادامه داره. پس قرارمون هر پنجشنبه و جمعه با کلی تخفیف داغ ;)
                            </p>
                        </div>
                        <div className="timer-box xmt-3 xmt-lg-6">
                            <TimerCart dataTime="april 28, 2022 18:37:25" theme="purple-dark-timer"/>
                        </div>
                    </div>
                </div>
                <div className="container card-wrapper xpt-5">
                    <div className="bundles-box">
                        <Bundle theme="purple-dark"/>
                        <Bundle theme="purple-dark"/>
                        <Bundle theme="purple-dark"/>
                        <Bundle theme="purple-dark"/>
                        <Bundle theme="purple-dark"/>
                        <Bundle theme="purple-dark"/>
                    </div>
                    <div className="pagination-wrapper d-flex justify-content-center align-content-center">
                        <nav aria-label="Page navigation example">
                            <ul className="pagination persian-number xm-0">
                                <li className="page-item active"><a className="page-link" href="#">1</a></li>
                                <li className="page-item"><a className="page-link" href="#">2</a></li>
                                <li className="page-item"><a className="page-link" href="#">3</a></li>
                                <li className="page-item">
                                    <a className="page-link" href="#" aria-label="Next">
                                        <span aria-hidden="true"><IconName name="last_page" className="icon"/></span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default BundlesPage;
